import React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components/macro";
import { useHistory } from "react-router-dom";
import { HelpMainOuterContainer, HelpStandardImage } from "./Help.styles";
import getInTouch from "../../assets/images/getInTouch.png";
import { GetTypographyContent } from "../../components/shared/Typography/Typography";
import { Button } from "../../components/shared/Button/Button";

const SimpleDiv = styled.div`
  padding-top: 20px;
  max-width: 300px;
  text-align: center;
`;

export const GetInTouch = (): React.ReactElement => {
  const { t } = useTranslation();
  const history = useHistory();
  return (
    <HelpMainOuterContainer>
      <HelpStandardImage src={getInTouch} alt="Get in touch" />
      <SimpleDiv>
        {GetTypographyContent({
          content: t("help.getInTouch.prompt"),
          size: "h3",
          isBold: true,
          padding: "10px 0",
        })}
      </SimpleDiv>
      <SimpleDiv>
        <Button
          label={t("help.getInTouch.button")}
          size="medium"
          onClick={() => history.push("contactUs")}
          reverse
        />
      </SimpleDiv>
    </HelpMainOuterContainer>
  );
};
